import React, { useState } from "react";
import { Grid, Carousel } from "@scuf/common";
import Bar from "../../components/charts/Bar/Bar";
import BarRotativo from "../../components/charts/Bar/BarRotativo";
import LineRotativo from "../../components/charts/Line/LineRotativo";
import DatTabRotativo from "../../components/common/DatTab/DatTabRotativo";
import Column from "../../components/charts/Column/Column";
import KPIStat from "../../components/common/KPIStat/KPIStat";
import BarStacked from "../../components/charts/BarStacked/BarStacked";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";

const width = window.innerWidth;

const Infraestructura = () => {
  return (
    <>
      <Grid className="m-0 p-0">
        <Grid.Row>
          <Grid.Column
            xsWidth="12"
            sWidth="2"
            mWidth="2"
            lWidth="2"
            xlWidth="2"
          >
            <div style={{ padding: "0px" }}>
              <KPIStat
                url="sp_GetData"
                body={{ params: "030101" }}
                isCard="1"
                titleCard={"GLOBAL"}
              />
            </div>
          </Grid.Column>
          <Grid.Column
            xsWidth="12"
            sWidth="2"
            mWidth="2"
            lWidth="2"
            xlWidth="2"
          >
            <div style={{ padding: "0px" }}>
              <KPIStat
                url="sp_GetData"
                body={{ params: "030102" }}
                isCard="1"
                titleCard="CHUQUICAMATA"
              />
            </div>
          </Grid.Column>
          <Grid.Column
            xsWidth="12"
            sWidth="2"
            mWidth="2"
            lWidth="2"
            xlWidth="2"
          >
            <div style={{ padding: "0px" }}>
              <KPIStat
                url="sp_GetData"
                body={{ params: "030103" }}
                isCard="1"
                titleCard="MINISTRO HALES"
              />
            </div>
          </Grid.Column>

          <Grid.Column
            xsWidth="12"
            sWidth="2"
            mWidth="2"
            lWidth="2"
            xlWidth="2"
          >
            <div style={{ padding: "0px" }}>
              <KPIStat
                url="sp_GetData"
                body={{ params: "030104" }}
                isCard="1"
                titleCard="SALVADOR"
              />
            </div>
          </Grid.Column>
          <Grid.Column
            xsWidth="12"
            sWidth="2"
            mWidth="2"
            lWidth="2"
            xlWidth="2"
          >
            <div style={{ padding: "0px" }}>
              <KPIStat
                url="sp_GetData"
                body={{ params: "030105" }}
                isCard="1"
                titleCard="ANDINA"
              />
            </div>
          </Grid.Column>
          <Grid.Column
            xsWidth="12"
            sWidth="2"
            mWidth="2"
            lWidth="2"
            xlWidth="2"
          >
            <div style={{ padding: "0px" }}>
              <KPIStat
                url="sp_GetData"
                body={{ params: "030106" }}
                isCard="1"
                titleCard="EL TENIENTE"
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid className="m-0 p-0">
        <Grid.Row>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            <div style={{ padding: "0px", width: "100%" }}>
              <BarRotativo
                url="sp_GetData"
                body={[
                  { params: "030201" },
                  { params: "030301" },
                  { params: "030401" },
                  { params: "030501" },
                  { params: "030601" },
                ]}
                isCard="0"
                titleCard=""
                name="Sistema"
              />
            </div>
          </Grid.Column>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            <div style={{ padding: "0px" }}>
              <LineRotativo
                url="sp_GetData"
                body={[
                  { params: "030202" },
                  { params: "030302" },
                  { params: "030402" },
                  { params: "030502" },
                  { params: "030602" },
                ]}
                isCard="0"
                yAxisTitle=""
                titleCard="&nbsp;"
                randomSeries={""}
              />
            </div>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row style={{ marginTop: "10px" }}>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            <div>
              <LineRotativo
                url="sp_GetData"
                body={[
                  { params: "030202" },
                  { params: "030302" },
                  { params: "030402" },
                  { params: "030502" },
                  { params: "030602" },
                ]}
                isCard="0"
                yAxisTitle=""
                titleCard="ANALISIS ALARMAS PROCESOS"
                randomSeries={""}
              />
            </div>
          </Grid.Column>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            <div>
              <LineRotativo
                url="sp_GetData"
                body={[
                  { params: "030202" },
                  { params: "030302" },
                  { params: "030402" },
                  { params: "030502" },
                  { params: "030602" },
                ]}
                isCard="0"
                yAxisTitle=""
                titleCard="ANALISIS ALARMAS SISTEMA"
                randomSeries={""}
              />
            </div>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row style={{ marginTop: "30px" }}>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            <div>
              <LineRotativo
                url="sp_GetData"
                body={[
                  { params: "030202" },
                  { params: "030302" },
                  { params: "030402" },
                  { params: "030502" },
                  { params: "030602" },
                ]}
                isCard="0"
                yAxisTitle=""
                titleCard="TAGS ALARMADOS PROCESOS"
                randomSeries={""}
              />
            </div>
          </Grid.Column>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            <div>
              <LineRotativo
                url="sp_GetData"
                body={[
                  { params: "030202" },
                  { params: "030302" },
                  { params: "030402" },
                  { params: "030502" },
                  { params: "030602" },
                ]}
                isCard="0"
                yAxisTitle=""
                titleCard="TAGS ALARMADOS SISTEMAS"
                randomSeries={""}
              />
            </div>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            <div
              style={{
                width: isMobile ? "98%" : 0.49 * width,
                marginTop: "0px",
              }}
            >
              <DatTabRotativo
                url="sp_GetData"
                body={[
                  { params: "020703" },
                  { params: "020803" },
                  { params: "020903" },
                  { params: "021003" },
                  { params: "021103" },
                ]}
                isCard="0"
                titleCard="ESTADO SERVIDORES"
              />
            </div>
          </Grid.Column>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            <div
              style={{
                width: isMobile ? "98%" : 0.49 * width,
                marginTop: "0px",
              }}
            >
              <DatTabRotativo
                url="sp_GetData"
                body={[
                  { params: "021103" },
                  { params: "021003" },
                  { params: "020903" },
                  { params: "020803" },
                  { params: "020703" },
                ]}
                isCard="0"
                titleCard="CASOS ABIERTOS SOPORTE"
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default Infraestructura;
